<div class="rich-text-editor-wrapper">
  <div #editorContainer class="rich-text-editor"></div>
</div>
